/** Shared brand asset paths (Vite `public/`). */
export const brandAssets = {
  /** Dark glyph on transparent — use on light backgrounds. */
  monitorIconOnLight: '/ghost-monitor-icon.svg',
  /** White glyph (black plate blends into dark panels) — use on dark backgrounds. */
  monitorIconOnDark: '/ghost-screen-white-on-black.svg',
  /** Canonical wordmark (dark fill) — invert for dark UI. */
  wordmark: '/ghostscreens-wordmark.svg',
  loginBrandBg: '/login/brand-bg.png',
  /** @deprecated Prefer monitorIconOnLight / monitorIconOnDark. */
  monitorIcon: '/ghost-monitor-icon.svg',
} as const;
